import Actions from '../../odata/actions';

const actions = new Actions('stockType', 'stockTypes');

export default actions;
